// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const SearchBox = () => ({
   restrict: 'A',
   replace: true,
   controller: 'SearchBoxCtrl',
   templateUrl: '/assets/searchBox.html'
})

angular.module('summonApp.directives')
   .directive('searchBox', SearchBox)
